import { FaRegHandshake } from "react-icons/fa";
import Button from "../../../components/Button/Button";
import { useTranslation } from "react-i18next";
import MqttService from "../../../services/MqttService";
import { useEffect, useRef, useState } from "react";
import { useSSEContext } from "../../../contexts/sse";
import { useUserStore } from "../../../contexts/userStore";
import { v4 as uuidv4 } from "uuid";

const ADJUST_READER_COMMAND_TIMEOUT = 15000;
const CLEAR_STATUS_TIMEOUT = 6000;

export function SendAdjustButton({ reader, ...props }) {
   const { t } = useTranslation();
   const [isSending, setIsSending] = useState(false);
   const { subscribeToActions, sseReceived } = useSSEContext();
   const { selectedCondominio } = useUserStore();
   const replyTimeoutRef = useRef(null);
   const [responseData, setResponseData] = useState({ status: null });

   async function sendAdjustCommand(reader) {
      setIsSending(true);
      setResponseData({ status: null });

      const mqttId = uuidv4();

      const response = await MqttService.sendAdjustReaderCommand({
         mqtt_id: mqttId,
         readerUuid: reader.uuid
      });
      subscribeToActions(['adjustReaderCommandReply', 'adjustedReader'], selectedCondominio);

      if (![200, 201].includes(response.status)) {
         setIsSending(false);
         setResponseData({ status: 'error' });
         return;
      }

      setResponseData(prevData => ({
         ...prevData,
         mqtt_id: mqttId,
      }));

      if (replyTimeoutRef.current) {
         clearTimeout(replyTimeoutRef.current);
      }

      replyTimeoutRef.current = setTimeout(() => {
         setIsSending(false);
         setResponseData({ status: 'error' });
      }, ADJUST_READER_COMMAND_TIMEOUT);
   }

   useEffect(() => {
      if (sseReceived?.action === 'adjustReaderCommandReply' && sseReceived.content.mqtt_id === responseData?.mqtt_id) {
         setResponseData(prevData => ({
            ...prevData,
            uuid: sseReceived.content.uuid,
            status: null,
         }));
      }
      if (sseReceived?.action === 'adjustedReader' && sseReceived.content.uuid === responseData?.uuid) {
         const status = sseReceived.content.status;
         setResponseData(prevData => ({
            ...prevData,
            status: status === 'finished' ? 'success' : 'error',
         }));
         clearTimeout(replyTimeoutRef.current);
         setIsSending(false);
      }
   }, [sseReceived]);

   useEffect(() => {
      return () => {
         if (replyTimeoutRef.current) {
            clearTimeout(replyTimeoutRef.current);
         }
      };
   }, []);

   useEffect(() => {
      const timer = setTimeout(() => {
         if (responseData.status === null) return;
         setResponseData({ status: null });
      }, CLEAR_STATUS_TIMEOUT);
      return () => clearTimeout(timer);
   }, [responseData.status]);

   return (
      <div className='flex justify-end flex-row w-full'>
         <Button
            className="px-3.5! [&>.button-container]:gap-1.5!"
            icon={<FaRegHandshake size={20} />}
            label={t("common.adjust")}
            onClick={() => sendAdjustCommand(reader)}
            isLoading={isSending}
            status={responseData.status}
         />
      </div>
   );
}